module.exports = __webpack_public_path__ + "static/media/Teamwork.fc664ed6.jpg";